var moya = moya || {};
moya.sereq = moya.sereq || {};

jQuery.extend(moya.sereq, {
	openingHours: {
		weekdays: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
		addDays: function() {
			var weekdays = [];
			$('input[name="weekdays[]"]:checked', '#sereqOpeningHoursForm').each(function() {
				weekdays.push($(this).val());
			});

			var data = {
				opens: $('#opens', '#sereqOpeningHoursForm').val(),
				closes: $('#closes', '#sereqOpeningHoursForm').val(),
				weekdays: weekdays
			};

			if (data.opens && data.closes && data.weekdays) {
				var value = JSON.stringify(data);
				var element = $('<input>')
					.attr('name', 'days[]')
					.attr('type', 'hidden')
					.val(value);

				$('#sereqOpeningHoursForm').append(element);

				var weekdayStrings = [];
				weekdays.forEach(function(day) {
					if (moya.sereq.openingHours.weekdays[day]) {
						weekdayStrings.push(moya.sereq.openingHours.weekdays[day]);
					}
				});

				var line = $('<div class="well__line">');
				line.append(data.opens + ' - ' + data.closes + ' / ' + weekdayStrings.join(', '));
				$('.well', '#sereqOpeningHoursForm').append(line);
			}
		}
	},

	calendar: {
		serviceId: null,
		locationId: null,
		begins: null,
		ends: null,
		bindEvents: function() {
			$('.booking__registrationNumber', '#sereqCalendar').on('click', function(event) {
				moya.sereq.calendar.onBookingClick(event);
			});
		},
		load: function(serviceId, locationId, begins, ends) {
			var $calendar = $('#sereqCalendar');

			if (!locationId) {
				locationId = $('#locationId', '#sereq').val();
			}

			if (locationId < 1) {
				return;
			}

			if (!serviceId) {
				serviceId = $calendar.data('serviceid');
			}

			var action = $calendar.data('action');

			// Store last used values
			moya.sereq.calendar.serviceId = serviceId;
			moya.sereq.calendar.locationId = locationId;
			moya.sereq.calendar.begins = begins;
			moya.sereq.calendar.ends = ends;

			$.ajax({
				url: '/_/moya/sereq/ajax/' + action,
				method: 'GET',
				data: {
					serviceId: serviceId,
					locationId: locationId,
					begins: begins,
					ends: ends
				}
			}).done(function(r) {
				if (r) {
					$calendar.replaceWith(r);
					moya.sereq.calendar.bindEvents();
				}
			});
		},
		previousWeek: function(action, begins, ends) {
			moya.sereq.calendar.load(
				moya.sereq.calendar.serviceId,
				moya.sereq.calendar.locationId,
				begins,
				ends
			);

			return false;
		},
		nextWeek: function(action, begins, ends) {
			moya.sereq.calendar.load(
				moya.sereq.calendar.serviceId,
				moya.sereq.calendar.locationId,
				begins,
				ends
			);

			return false;
		},
		onLocationChange: function(event) {
			var locationId = $(event.target).val();

			if (locationId > 0) {
				moya.sereq.calendar.load(
					moya.sereq.calendar.serviceId,
					locationId,
					moya.sereq.calendar.begins,
					moya.sereq.calendar.ends
				);
			}
		},
		onBookingClick: function(event) {
			var $dialog = $(event.target).next().clone();
			$dialog.dialog({
				modal: true,
				minWidth: 500
			});
		}
	},

	form: {
		cleanRegistrationNumber: function(no) {
			return no.toUpperCase().replace(/[^a-zA-Z0-9]/gi,'');
		}
	},

	schedule: {
		bindEvents: function() {
			// Populate schedule element with data from widget
			$("#sereqDayScheduleSelector").on("selected.artsy.dayScheduleSelector", function (e, selected) {
				var $schedule = $("#schedule", "#sereqLocationServiceForm"),
					data = $("#sereqDayScheduleSelector").data("artsy.dayScheduleSelector").serialize();
				$schedule.val(JSON.stringify(data));
			})
		},
		init: function() {
			$("#sereqDayScheduleSelector").dayScheduleSelector();
			moya.sereq.schedule.bindEvents();
		},
		populate: function(data) {
			data = JSON.parse(data);
			$("#sereqDayScheduleSelector").data("artsy.dayScheduleSelector").deserialize(data);
		}
	}
});
